import { Injectable, Type } from '@angular/core';
import { Task } from '../../../shared/entities/task/task';
import { ControlTemplate } from '../../form/entities/controlTemplate';
import { TaskFormHandler } from './task-form-handler.interface';
import { RefuelFormViewComponent } from './components/refuel-form-view.component';

/**
 * State exposed by the ResourceRefuelFormHandler
 */
interface ResourceRefuelFormState {
  task?: Task;
  template?: ControlTemplate;
}

/**
 * Handler for resourceRefuelForm
 * Manages refueling resource assignment forms
 */
@Injectable()
export class ResourceRefuelFormHandler implements TaskFormHandler {
  readonly formKey = 'resourceRefuelForm';
  
  // Private properties
  private task?: Task;
  private template?: ControlTemplate;

  canHandle(formKey: string): boolean {
    return formKey === this.formKey;
  }

  getComponent(): Type<any> | null {
    return RefuelFormViewComponent;
  }

  initialize(task: Task, template: ControlTemplate | null): void {
    this.task = task;
    this.template = template ?? undefined;
    
    console.log('[ResourceRefuelFormHandler] Initialized for task:', task.id);
  }

  getState(): ResourceRefuelFormState {
    return {
      task: this.task,
      template: this.template
    };
  }

  destroy(): void {
    console.log('[ResourceRefuelFormHandler] Destroying handler');
  }
}
